enum IPSServiceOption {
    PREMIUM = 'Premium',
    DISCOUNTED = 'DiscountedServices',
    NO_FEE = 'NoFee'
}

export default IPSServiceOption;